var PRESS = [
    {k:"monogram", n:"Monogram", max:3,  surcharge:0, hint:"MJH"},
    {k:"quote",    n:"Quote",    max:18, surcharge:5, hint:"BEGIN AGAIN"}
  ];


  var PLACEMENTS = [
    {n:"Lower right",   reads:"landscape", at:[.88, .74], room:false},
    {n:"Lower centre",  reads:"landscape", at:[.50, .74], room:true},
    {n:"Upper right",   reads:"landscape", at:[.88, .20], room:false},
    {n:"Centre",        reads:"landscape", at:[.50, .50], room:true},
    {n:"Front, upright",reads:"portrait",  at:[.50, .82], room:true},
    {n:"Spine",         reads:"portrait",  at:[.12, .82], room:false},
    /*
      THE COVEN PLACEMENT. The Grimoire is a bi-fold and its press sits in
      one place only: the bottom right of the front cover, reading upright
      with the book held normally — so `portrait`, not the atelier's
      carried-flat `landscape`.

      `anchor: "end"` is what keeps a quote on the cover. Every atelier
      placement centres the press on its point, which is why the corners
      are `room: false` — two lines centred on a corner hang off the edge,
      and that is exactly what this sheet did to #1122309. Anchored to its
      right-hand end instead, the press grows leftwards INTO the cover, so
      eighteen characters fit where three do.

      The numbers are the customer preview's own: its press ends at 89% of
      the cover's width and is centred on 88% of its height. The drawing
      the bench works from and the drawing the customer approved have to
      agree, so they are taken from the same place.
    */
    {n:"Front cover, lower right", reads:"portrait", at:[.89, .88],
     room:true, anchor:"end"}
  ];

  var CARRY_TURN = -90;



  var COVER = { w:232, h:329, cx:200, cy:178 };

  var PRESS_PX = 17, LINE_PX = 20;

  function pressLines(str){
    if (!str) return [];
    if (str.length <= 10 || str.indexOf(" ") === -1) return [str];
    var mid = str.length / 2, best = -1;
    for (var i = 0; i < str.length; i++)
      if (str[i] === " " && (best === -1 || Math.abs(i - mid) < Math.abs(best - mid)))
        best = i;
    if (best === -1) return [str];
    return [str.slice(0, best), str.slice(best + 1)];
  }

  function setPressText(el, str){
    while (el.firstChild) el.removeChild(el.firstChild);
    var rows = pressLines(str);
    // lift the block so two lines straddle the placement point rather
    // than hanging below it
    var top = -(rows.length - 1) * LINE_PX / 2;
    rows.forEach(function(line, i){
      var t = document.createElementNS("http://www.w3.org/2000/svg", "tspan");
      t.setAttribute("x", 0);
      t.setAttribute("dy", i === 0 ? top : LINE_PX);
      t.textContent = line;
      el.appendChild(t);
    });
  }

function atelierOrderInit(host){
  "use strict";

  var DATA = JSON.parse(host.querySelector("[data-atelier-data]").textContent);
  var CDN = DATA.cdn, FOLIOS = DATA.folios, LACES = DATA.laces;
  var CHARMS = DATA.charms, EMBOSS = DATA.emboss, COLOURS = DATA.colours;
  var BOOKS = DATA.books, CHARS = DATA.chars;

  /* A product carries a colour NAME; the shop setting turns names into
     colours. The sheet resolves them the same way the configurator
     does, once, so the two cannot disagree about what Rose Quartz is.
     A name with no entry stays null and draws hatched — the bench
     should see a gap, not a guess, on a folio about to be cut. */
  /* A FOLIO NOW CARRIES ITS OWN COLOUR.

     The name lookup stays as the fallback, because most of the range
     still uses it — but a name only becomes a colour by way of a list
     typed into a theme setting, and a folio added to the range without a
     line in that list drew with fill="null". The Grimoire is the first
     one that would have. The product's own swatch cannot fall out of
     step with a setting nobody remembers to update. */
  FOLIOS.forEach(function(x){ x.hex = x.hex || COLOURS[x.n] || null; });
  LACES.forEach(function(x){ x.hex = COLOURS[x.n] || null; });

  /* ---- read the build off the URL ------------------------------------
     Everything a sheet shows comes off the link. Nothing is looked up in
     the cart, in a session, or in an app: a link in an email six months
     from now draws the same folio it drew on the day. Each sheet is
     handed its own `param` reader, so a batch is just several of them. */
  function parseSpec(raw){
    var out = {};
    if (!raw) return out;
    raw.split(";").forEach(function(pair){
      var i = pair.indexOf("=");
      if (i < 0) return;
      out[pair.slice(0, i)] = decodeURIComponent(pair.slice(i + 1));
    });
    return out;
  }

  var byName = function(list, n){
    for (var i = 0; i < list.length; i++) if (list[i].n === n) return list[i];
    return null;
  };
  var byHandle = function(list, h){
    for (var i = 0; i < list.length; i++) if (list[i].h === h) return list[i];
    return null;
  };
  var bySku = function(list, sku){
    for (var i = 0; i < list.length; i++) if (list[i].sku === sku) return list[i];
    return null;
  };
  function placement(n){ return byName(PLACEMENTS, n) || PLACEMENTS[0]; }

  /* ---- one sheet, or a whole desk ------------------------------------
     A desk's worth of worksheets prints in one go, so nobody stands at the
     printer opening links one at a time. Every job rides in the URL the
     same way a single one always has — repeated parameters, read in
     parallel — so an existing one-job link from the Flow email still
     works unchanged.

     A batch is never mixed: the atelier desks are all builds and the
     monogram desks are all monograms, so `o`/`n`/`d` can be shared
     between the two shapes without the pairing going wrong. */
  function job(obj){ return function(k){ return obj[k] == null ? "" : obj[k]; }; }

  function readJobs(){
    var q = new URLSearchParams(location.search);
    var o = q.getAll("o"), n = q.getAll("n"), d = q.getAll("d"), out = [];
    /* A gift set is checked before the monogram: its link carries `mono`
       too, and read as a monogram it would print with no lacing on it. */
    var gifts = q.getAll("g");
    if (gifts.length){
      var gs = q.getAll("gs"), gk = q.getAll("gk"), gf = q.getAll("f"),
          gm = q.getAll("mono"), gp = q.getAll("place"),
          gl = q.getAll("lace"), gx = q.getAll("loose"), gb = q.getAll("belly"),
          gn = q.getAll("note"),
          /* WHAT TO PRESS, AND IN WHICH FINISH. Read here or they do not
             exist: `param` reads the job this builds, not the URL. */
          gki = q.getAll("kind"), gfi = q.getAll("fin");
      gifts.forEach(function(g, i){
        out.push(job({ g:g, gs:gs[i], gk:gk[i], f:gf[i], mono:gm[i], place:gp[i],
                       kind:gki[i], fin:gfi[i],
                       belly:gb[i], lace:gl[i], loose:gx[i], note:gn[i], o:o[i], n:n[i], d:d[i] }));
      });
      return out;
    }
    var monos = q.getAll("mono");
    if (monos.length){
      var item = q.getAll("item"), sku = q.getAll("sku"),
          place = q.getAll("place"), desk = q.getAll("desk"),
          /* WHAT TO PRESS, AND IN WHICH FINISH. New in bench v22. Absent
             on an older link, where both default below to what every
             off-the-shelf press was before the Coven range. */
          mkind = q.getAll("kind"), mfin = q.getAll("fin");
      monos.forEach(function(m, i){
        out.push(job({ mono:m, item:item[i], sku:sku[i], place:place[i],
                       desk:desk[i], kind:mkind[i], fin:mfin[i],
                       o:o[i], n:n[i], d:d[i] }));
      });
      return out;
    }
    q.getAll("b").forEach(function(b, i){
      out.push(job({ b:b, o:o[i], n:n[i], d:d[i] }));
    });
    return out;
  }

  /* Every drawing carries its own gradient and hatch, referenced by id. A
     cloned sheet duplicates those ids, and `url(#x)` then resolves to the
     FIRST match in the document — so without this every folio in a batch
     would be painted with the first one's foil. The defs happen to be
     identical today, which is exactly why this would go unnoticed until
     they were not. */
  function uniquifyIds(root, k){
    var map = {};
    [].forEach.call(root.querySelectorAll("[id]"), function(el){
      map[el.id] = el.id + "--" + k;
      el.id = map[el.id];
    });
    [].forEach.call(root.querySelectorAll("*"), function(el){
      ["fill","stroke","clip-path","filter","mask","data-foil","data-hatch","aria-labelledby"]
        .forEach(function(a){
          var v = el.getAttribute(a);
          if (!v) return;
          var out = v;
          for (var old in map){
            out = out.split("url(#" + old + ")").join("url(#" + map[old] + ")");
            if (out === old) out = map[old];
          }
          if (out !== v) el.setAttribute(a, out);
        });
    });
  }

  /* `title~sku~qty|title~sku~qty` — the bench writes it, this reads it.
     Titles have had ~ and | taken out on the way in, so the split is safe. */
  function giftList(raw){
    return String(raw || "").split("|").filter(Boolean).map(function(part){
      var b = part.split("~");
      var q = parseInt(b[2] || "1", 10);
      return { t: b[0] || "", sku: b[1] || "", qty: q > 0 ? q : 1, h: b[3] || "" };
    });
  }

  function paintSheet(sheet, param){

    /* ---- a gift set ------------------------------------------------------
       Drawn on the build sheet, because the job is a build: a folio pressed
       and then laced with notebooks, the same as the atelier. What differs
       is where the contents come from — the set's own list, carried on the
       link by the bench — and that nothing about it was configured by the
       customer except the initials. */
    var GIFT = param("g") ? {
      set: param("gs"), sku: param("gk"), folio: param("f"),
      mono: (param("mono") || "").trim(), place: param("place") || "Lower right",
      /* Both off the link, both with the old behaviour as the default, so
         a link sent before the bench carried them still prints exactly as
         it used to: a neutral monogram. */
      kind: param("kind") || "monogram",
      fin: (param("fin") || "").trim(),
      lace: giftList(param("lace")), loose: giftList(param("loose")),
      belly: giftList(param("belly")),
      note: (param("note") || "").trim()
    } : null;

    /* ---- an off-the-shelf monogram --------------------------------------
       Same page, same link-then-print gesture as a build sheet, so the room
       learns ONE process for every personalised order rather than two.
       There is no build to unpack: everything is already on the URL,
       because the bench sheet had it all along.

           ?mono=DAD&item=Refillable+Folio+in+Periwinkle+Blue&sku=FN5051PER
           &place=Lower+right&desk=Folio+press&o=%231115601&n=Olivia&d=28+Aug+2026

       Checked BEFORE the folio guard below. Without that a monogram link is
       told it has no build on it, which is true and useless. */
    var MONO = GIFT ? "" : param("mono");

    /* A PRESS LINK THAT CARRIES NO LETTERING.
       It should not happen — the bench does not queue a press with
       nothing to press — but when it did, this fell through to the build
       sheet's "no ?b= value" error, which is the wrong question asked of
       the wrong person. A press sheet with no lettering is a bench fault,
       and the sheet should say which fault it is. */
    if (!GIFT && !MONO && (param("item") || param("desk"))){
      sheet.innerHTML =
        '<div class="bad"><b>This press sheet has no lettering on it.</b><br><br>' +
        'The link carries the item and the desk but nothing to press. Check the ' +
        'order in Shopify for a <code>Monogram</code> or <code>Quote</code> property ' +
        'on the debossing line, and do not press anything until it is found.</div>';
      return;
    }

    if (MONO){
      /* Both default to what every off-the-shelf press was before the
         Coven range, so a link made by an older bench prints exactly as
         it used to. */
      var MKIND = (param("kind") || "monogram").toLowerCase();
      var MFIN  = (param("fin") || "").trim();
      var MQUOTE = MKIND === "quote";
      var mesc = function(s){
        return String(s).replace(/[&<>"]/g, function(c){
          return { "&":"&amp;", "<":"&lt;", ">":"&gt;", '"':"&quot;" }[c];
        });
      };
      /* Spelt out one character at a time with the spaces marked, exactly as
         the build sheet does it. Three initials rarely go wrong; a name does,
         and the mistake that hides best is a missing space. */
      var mspelt = MONO.split("").map(function(ch){
        return ch === " " ? '<span class="sp">␣</span>' : mesc(ch);
      }).join(" ");
      var mline = function(k, v){
        return v ? '<dt>' + mesc(k) + '</dt><dd>' + mesc(v) + '</dd>' : "";
      };
      /* Each field escaped on its own — escaping the joined string would turn
         the separator entity into visible "&middot;" text. */
      var msub = [param("n"), param("d")].filter(Boolean).map(mesc).join(" &middot; ");
      /* The same break the press makes, from the same function the build
         sheet draws with — at the space nearest the middle. A sheet that
         showed the quote on one line would be showing something that is
         not what gets made. */
      var mbig = MQUOTE
        /* The style is inline on purpose: it is one declaration, and it
           keeps this to ONE file to install rather than two, on a sheet
           the bench prints from every morning. */
        ? pressLines(MONO).map(function(l){
            return '<span style="display:block">' + mesc(l) + '</span>';
          }).join("")
        : mesc(MONO);

      sheet.innerHTML =
        '<div class="hd"><div><h1>' + (MQUOTE ? 'Quote sheet' : 'Monogram sheet') + '</h1>' +
          '<div class="sub">' + msub + '</div></div>' +
          '<div class="ord">Order<b>' + mesc(param("o") || "—") + '</b></div></div>' +
        '<h2>The item</h2>' +
        '<p class="mono__item">' + mesc(param("item") || "—") + '</p>' +
        (param("sku") ? '<p><span class="mono__sku">' + mesc(param("sku")) + '</span></p>' : "") +
        '<h2>The lettering</h2>' +
        '<div class="mono__big">' + mbig + '</div>' +
        '<div class="mono__spelt">' + mspelt + '</div>' +
        '<dl class="meta">' +
          mline("Placement", param("place")) +
          /* The finish before the desk, because it is the thing that goes
             wrong: a gold foil press done neutral is a folio to remake.
             Printed only when the link carries one. An off-the-shelf
             press had no finish to carry before the Coven range, and a
             sheet that filled in "Neutral" on its own would be stating as
             fact something nobody put on the order. */
          mline("Finish", MFIN) +
          mline("Press desk", param("desk")) +
          mline("Characters", String(MONO.length) +
                (MQUOTE ? " \u00b7 set over two lines" : "")) +
        '</dl>' +
        '<div class="mono__ticks">' +
          '<span><i class="box"></i> Pressed</span>' +
          '<span><i class="box"></i> Checked</span>' +
        '</div>' +
        '<div class="ft"><span>Creator\'s Friend — personalisation</span>' +
          '<span>' + mesc(param("o") || "") + '</span></div>';
      document.title = "Monogram sheet " + (param("o") || "");
      return;
    }

    /* `e` and `k` WERE HARDCODED HERE — "Neutral" and "monogram".

       A gold foil set printed, and drew, as neutral: the bench would have
       pressed it in the wrong finish with nothing on the sheet to say so.
       And an eighteen-character quote printed as "Monogram — 18 of 3
       characters", which is the sheet contradicting itself on the one
       line the press is set from. */
    var S = GIFT
      ? { f: GIFT.folio,
          e: GIFT.mono ? (GIFT.fin || "Neutral") : "",
          k: GIFT.kind === "quote" ? "quote" : "monogram",
          t: GIFT.mono, p: GIFT.place }
      : parseSpec(param("b"));
    var folio = bySku(FOLIOS, S.f);

    if (!folio && GIFT){
      var gesc = function(v){
        return String(v).replace(/[&<>"]/g, function(c){
          return { "&":"&amp;", "<":"&lt;", ">":"&gt;", '"':"&quot;" }[c];
        });
      };
      sheet.innerHTML =
        '<div class="bad"><b>This gift-set sheet cannot name its folio.</b><br><br>' +
        (S.f ? 'It asks for <code>' + gesc(S.f) + '</code>, which is not in the folio range.'
             : 'The link has no folio on it.') +
        ' Check the set\'s Gift contents in Shopify — it needs one product of type ' +
        '<b>Notebook Cover</b> — and print the sheet again from the bench.</div>';
      return;
    }
    if (!folio){
      sheet.innerHTML =
        '<div class="bad"><b>This order sheet has no build on it.</b><br><br>' +
        'The link needs a <code>?b=</code> value — the <code>_spec</code> property from the ' +
        'folio line of the order. Without it there is nothing to draw, and a sheet ' +
        'that guessed would be worse than one that says so.</div>';
      return;
    }

    /* ---- the build, unpacked ------------------------------------------- */
    /* A gift set's lace, when it has one, REPLACES the folio's own belly
       lace — Weekly Glaze is a Saddle Brown folio on a Vintage Olive lace.
       Found by colour, the way an atelier build names its laces. */
    /* With no lace of its own in the set, the folio is drawn on its OWN
       belly lace — the one it ships with, in its own colour. A folio drawn
       with no lace at all reads as a lace missing from the box. */
    var belly = GIFT
      ? (GIFT.belly.length ? GIFT.belly.map(function(x){
          return byName(LACES, x.t) || { n: x.t, hex: COLOURS[x.t] || null };
        }) : [byName(LACES, folio.n) || { n: folio.n, hex: folio.hex }])
      : (S.bl || "").split(",").filter(Boolean).map(function(n){ return byName(LACES, n); });
    var inner = byName(LACES, S.il);
    /* `i` now carries handle*qty, the same grammar `c` has always used —
       four of one notebook is `ruled-note*4`, not the handle four times.
       Parsed the same way the charms below are, and for the same reason:
       read as a plain handle, "ruled-note*4" matches nothing and the sheet
       would tell the bench the title is not in the range any more. */
    var insertGroups = GIFT ? GIFT.lace.map(function(x){
      /* Found in the atelier's own range — by handle, then by title — so a
         notebook is drawn in the same colour the configurator draws it.
         One the range does not hold is drawn in plain paper: the set's
         contents are fixed, so here the drawing is counting, not checking. */
      var bk = (x.h && byHandle(BOOKS, x.h)) || null;
      if (!bk) for (var bi = 0; bi < BOOKS.length; bi++) if (BOOKS[bi].t === x.t){ bk = BOOKS[bi]; break; }
      return { book: bk || { t: x.t, hex: "#F7F3E9" }, qty: x.qty, handle: x.sku };
    }) : (S.i || "").split(",").filter(Boolean).map(function(t){
      var bits = t.split("*");
      var qty = parseInt(bits[1] || "1", 10);
      return { book: byHandle(BOOKS, bits[0]), qty: (qty > 0 ? qty : 1), handle: bits[0] };
    });
    /* Flat, for the DRAWING: four notebooks are drawn as four slots. The
       grouped form is what the pick list wants. */
    var inserts = [];
    insertGroups.forEach(function(g){
      for (var i = 0; i < g.qty; i++) inserts.push(g.book);
    });
    var charms = (S.c || "").split(",").filter(Boolean).map(function(t){
      var bits = t.split("*");
      return { charm: byHandle(CHARMS, bits[0]), qty: parseInt(bits[1] || "1", 10), handle: bits[0] };
    });
    var emboss  = S.e ? byName(EMBOSS, S.e) : null;
    var kind    = S.k === "quote" ? PRESS[1] : PRESS[0];
    var text    = S.t || "";
    var place   = placement(S.p);

    /* ---- draw, in both views -------------------------------------------
       The bench needs to know which way the press reads, and one picture
       cannot say that. Two can. */
    sheet.querySelectorAll("svg.folio").forEach(function(svg){
      var flat = svg.dataset.view === "carried";
      var FOIL  = "url(#" + svg.dataset.foil + ")";
      var HATCH = "url(#" + svg.dataset.hatch + ")";
      var turn = flat ? CARRY_TURN : 0;
      var rad = turn * Math.PI / 180, cos = Math.cos(rad), sin = Math.sin(rad);
      function toView(x, y){
        return { x: COVER.cx + x * cos - y * sin, y: COVER.cy + x * sin + y * cos };
      }
      var $ = function(id){ return svg.querySelector("[data-el=" + id + "]"); };

      // every id in the lifted markup is duplicated across the two svgs, so
      // look them up INSIDE each svg rather than through the document
      var q = function(sel){ return svg.querySelector(sel); };
      /* A folio with no colour anywhere draws HATCHED rather than
         fill="null", which paints nothing and reads as white leather. A
         gap should look like a gap on a folio about to be cut. */
      q("[data-el=body]").setAttribute("fill", folio.hex || HATCH);
      /* A BI-FOLD HAS NO FLAP. The tri-fold's fold line sits 21% in from
         the spine; drawn on a book-fold it is a crease in the leather
         that is not there. Which fold it is comes from the folio's own
         `custom.press_setup`, the same metafield the product page reads,
         so the drawing and the shop cannot disagree. */
      var flap = q("[data-el=flap]");
      if (flap) flap.style.display = folio.fold === "bi" ? "none" : "";
      q("[data-el=folio]").setAttribute("transform",
        "translate(" + COVER.cx + "," + COVER.cy + ") rotate(" + turn + ")");

      var LACE_W = 5, laceY;
      var r1 = q("[data-el=ribbon1]"), r2 = q("[data-el=ribbon2]");
      /* NOTHING IS EVER PAINTED `null`.

         This is the line that drew the black band across every Coven
         sheet — and the fallback above it was never the problem. A gift
         set with no lace of its own already falls back to the FOLIO'S
         own band, in the folio's colour; it is just that the folio's
         colour was null, because `json` was eating the swatch (see
         atelier-data). So the band was `fill="null"`, which is not a
         colour, and an invalid fill paints BLACK.

         Hatched is what this sheet already says everywhere else for "no
         colour known". Black reads as a decision; hatching reads as a
         gap, which is what it is. */
      r1.setAttribute("fill", (belly[0] || LACES[0] || {}).hex || HATCH);
      if (belly.length < 2){ laceY = -LACE_W / 2; r1.setAttribute("y", laceY); r2.style.display = "none"; }
      else {
        laceY = -LACE_W - 2; r1.setAttribute("y", laceY);
        r2.style.display = ""; r2.setAttribute("y", 2);
        r2.setAttribute("fill", belly[1].hex || HATCH);
      }
      if (inner) q("[data-el=innerlace]").setAttribute("stroke", inner.hex || HATCH);

      // inserts
      var slots = q("[data-el=slots]"), fore = q("[data-el=pages]");
      slots.innerHTML = ""; fore.innerHTML = "";
      var n = inserts.length, SW = 48, SH = 68, GAP = 10;
      var x0 = 200 - (n * SW + (n - 1) * GAP) / 2;
      inserts.forEach(function(bk, i){
        var hex = bk ? (bk.hex || (bk.c ? (COLOURS[bk.c] || null) : null)) : null;
        var x = x0 + i * (SW + GAP);
        slots.innerHTML += '<rect x="' + x + '" y="398" width="' + SW + '" height="' + SH +
          '" rx="1.5" fill="' + (hex || HATCH) + '" stroke="#1F1F1F" stroke-width="1.1"/>';
        fore.innerHTML += '<rect x="' + (COVER.w / 2 - 6) + '" y="' + (58 + i * 11) +
          '" width="12" height="8" fill="' + (hex || "#F7F3E9") + '" stroke="#1F1F1F" stroke-width="1"/>';
      });

      // charms
      var cg = q("[data-el=charms]");
      cg.innerHTML = "";
      var flat_list = [];
      charms.forEach(function(g){ for (var i = 0; i < g.qty; i++) flat_list.push(g.charm); });
      if (flat_list.length){
        var mid = laceY + LACE_W / 2;
        var e1 = toView(130, mid), e2 = toView(-130, mid);
        var end = e1.y >= e2.y ? e1 : e2;
        var PER_ROW = 5, SPREAD = 19, ROW_DROP = 23, R = 9, CORD = [20, 31, 25];
        flat_list.forEach(function(c, i){
          if (!c) return;
          var col = i % PER_ROW, row = Math.floor(i / PER_ROW);
          var cx = end.x + (col - (PER_ROW - 1) / 2) * SPREAD;
          var cy = end.y + CORD[i % CORD.length] + row * ROW_DROP;
          cg.innerHTML +=
            '<line x1="' + end.x.toFixed(1) + '" y1="' + end.y.toFixed(1) + '" x2="' + cx.toFixed(1) +
            '" y2="' + (cy - R).toFixed(1) + '" stroke="#1F1F1F" stroke-width="1.1" opacity=".75"/>' +
            '<circle cx="' + cx.toFixed(1) + '" cy="' + cy.toFixed(1) + '" r="' + R +
            '" fill="#F7F3E9" stroke="#1F1F1F" stroke-width="1.4"/>' +
            '<text x="' + cx.toFixed(1) + '" y="' + (cy + 3.5).toFixed(1) +
            '" text-anchor="middle" style="font:8px monospace" fill="#6E6553">' + c.n.charAt(0) + '</text>' +
            '<image href="' + c.img + '" x="' + (cx - R + 1).toFixed(1) + '" y="' + (cy - R + 1).toFixed(1) +
            '" width="' + (2 * R - 2) + '" height="' + (2 * R - 2) + '" clip-path="circle(' + (R - 1) +
            'px)" preserveAspectRatio="xMidYMid slice"/>';
        });
      }

      // the press
      var m = q("[data-el=mono]");
      if (!emboss || !text){ m.setAttribute("fill", "none"); setPressText(m, ""); }
      else {
        var L = (function(p){
          var a = p.at[0], d = p.at[1];
          if (p.reads === "landscape"){ var t = 1 - d; d = a; a = t; }
          return { x: (a - .5) * COVER.w, y: (d - .5) * COVER.h };
        })(place);
        var V = toView(L.x, L.y);
        var lean = (place.reads === "landscape" ? -CARRY_TURN : 0) + turn;
        setPressText(m, text);
        /* Centred unless the placement says otherwise. `text-anchor` is
           on the <text>, and the tspans are all at x=0, so the anchor
           decides which end of the line sits on the placement point. */
        m.setAttribute("text-anchor", place.anchor || "middle");
        var foil = emboss.n === "Gold foil";
        m.setAttribute("fill", foil ? FOIL : "rgba(0,0,0,.42)");
        m.setAttribute("stroke", foil ? "rgba(0,0,0,.5)" : "none");
        m.setAttribute("stroke-width", foil ? "0.9" : "0");
        m.setAttribute("paint-order", "stroke");
        m.setAttribute("x", 0); m.setAttribute("y", 0);
        m.setAttribute("transform",
          "translate(" + V.x.toFixed(1) + "," + V.y.toFixed(1) + ") rotate(" + lean + ")");
      }
    });

    /* The belly lace is drawn (above) — the set's own lace if it has one,
       otherwise the folio's. The inner lace is not: nothing is chosen
       about it, and the notebooks laced onto it are counted in the slots. */
    if (GIFT) sheet.querySelectorAll("svg.folio").forEach(function(svg){
      var il = svg.querySelector("[data-el=innerlace]"); if (il) il.setAttribute("stroke", "none");
      var sn = svg.querySelector("[data-el=slotnote]");
      if (sn) sn.textContent = GIFT.lace.reduce(function(n, x){ return n + x.qty; }, 0) + " TO LACE IN";
    });

    /* ---- the press instruction, unmistakable ---------------------------
       A press is set by hand, one character at a time, and the two ways to
       get it wrong are a misread glyph and a missed space. So the text is
       shown twice: once at size the way it will look, and once spaced out
       character by character with the spaces MARKED, because a run of
       eighteen characters is exactly where a lost space hides. */
    var pressBox = sheet.querySelector("[data-el=press]");
    if (GIFT && !text){
      pressBox.innerHTML = '<div style="color:#6E6553">No monogram — sent blank by request. ' +
        'Lace and pack only.</div>';
      sheet.querySelector("[data-el=pressmeta]").innerHTML = "";
    } else if (!emboss || !text){
      pressBox.innerHTML = '<div style="color:#6E6553">No press on this build.</div>';
      sheet.querySelector("[data-el=pressmeta]").innerHTML = "";
    } else {
      var rows = pressLines(text);
      pressBox.querySelector(".press__t").innerHTML =
        rows.map(function(r){ return r.replace(/ /g, "&nbsp;"); })
            .join('<span class="brk"> ⏎ </span>');
      pressBox.querySelector(".press__g").innerHTML =
        text.split("").map(function(ch){
          return ch === " " ? '<span class="sp">␣</span>' : ch;
        }).join(" ");
      sheet.querySelector("[data-el=pressmeta]").innerHTML =
        /* A gift set's monogram is the off-the-shelf press, not an atelier
           finish — the same station and heat as a folio bought on its own. */
        /* The finish, and the desk that holds it. A gift set's neutral
           press is the off-the-shelf folio press; its gold foil press is
           done at the atelier's gold foil desk, because that is where the
           foil is. The bench sheet queues it there; this says so too. */
        /* `emboss.n` is a variant title from the theme's own data, and
           the line below prints it unescaped for the same reason. `pesc`
           is not in scope yet here — it is declared with the pick list,
           further down. */
        (GIFT ? '<dt>Press</dt><dd>' + emboss.n + ' — ' +
                (emboss.n === "Gold foil" ? "gold foil desk"
                                          : "folio monogram press") + '</dd>'
              : '<dt>Finish</dt><dd>' + emboss.n + '</dd>') +
        '<dt>Kind</dt><dd>' + kind.n + ' — ' + text.length + ' of ' + kind.max + ' characters</dd>' +
        '<dt>Lines</dt><dd>' + rows.length + '</dd>' +
        '<dt>Placement</dt><dd>' + place.n + '</dd>' +
        '<dt>Reads</dt><dd>' + (place.reads === "landscape"
          ? "with the folio carried flat" : "with the folio standing upright") + '</dd>';
    }

    /* ---- what to pick ---------------------------------------------------- */
    var pick = [];
    var pesc = function(v){
      return String(v).replace(/[&<>"]/g, function(c){
        return { "&":"&amp;", "<":"&lt;", ">":"&gt;", '"':"&quot;" }[c];
      });
    };
    if (GIFT){
      /* In the order the bench works it: press, then lace, then pack. The
         titles came off a link, so every one is escaped before it is drawn. */
      pick.push({ what: "Folio — " + pesc(folio.n),
                  ref: pesc(folio.sku), qty: 1 });
      GIFT.belly.forEach(function(x){
        pick.push({ what: "Belly lace — " + pesc(x.t) + ", swap for the folio's own",
                    ref: pesc(x.sku), qty: x.qty });
      });
      GIFT.lace.forEach(function(x){
        pick.push({ what: "Lace in — " + pesc(x.t), ref: pesc(x.sku), qty: x.qty });
      });
      GIFT.loose.forEach(function(x){
        pick.push({ what: "Pack loose — " + pesc(x.t), ref: pesc(x.sku), qty: x.qty });
      });
      if (text) pick.push({
        what: "Press \u2014 " + (kind.k === "quote" ? "quote, two lines" : "monogram") +
              ", " + pesc(emboss ? emboss.n : "Neutral") +
              (emboss && emboss.n === "Gold foil" ? ", gold foil desk" : ", folio press"),
        ref: kind.k, qty: 1 });
      /* The customer's own words, so they go on the sheet in full and
         in quotes — the packer copies them onto the card from here. */
      if (GIFT.note) pick.push({ what: "Gift note — “" + pesc(GIFT.note) + "”",
                                 ref: "card", qty: 1 });
    } else {
    pick.push({ what: "Folio — " + folio.n, ref: folio.sku, qty: 1 });
    if (inner) pick.push({ what: "Lace — " + inner.n, ref: "inner", qty: 1 });
    belly.forEach(function(l){ if (l) pick.push({ what: "Lace — " + l.n, ref: "belly", qty: 1 }); });
    /* One row reading 4, not four rows — the same choice the charms make,
       so a build of four identical notebooks is picked once and counted,
       rather than ticked four times. */
    insertGroups.forEach(function(g){
      pick.push({ what: "Insert — " + (g.book ? g.book.t : "UNKNOWN"),
                  ref: g.handle, qty: g.qty, missing: !g.book });
    });
    charms.forEach(function(g){
      pick.push({ what: "Charm — " + (g.charm ? g.charm.n : "UNKNOWN"),
                  ref: g.handle, qty: g.qty, missing: !g.charm });
    });
    if (emboss && text)
      pick.push({ what: "Press — " + emboss.n + (kind.surcharge ? ", long" : ""),
                  ref: kind.k, qty: 1 });
    }

    sheet.querySelector("[data-el=pick]").innerHTML = pick.map(function(r){
      return '<tr><td class="tick"><span class="box"></span></td><td' +
        (r.missing ? ' style="color:#C62A20"' : '') + '>' + r.what +
        (r.missing ? ' — not in the range any more' : '') +
        '</td><td style="color:#6E6553">' + r.ref + '</td><td class="q">' + r.qty + '</td></tr>';
    }).join("");

    /* ---- header ---------------------------------------------------------- */
    var order = param("o"), when = param("d"), who = param("n");
    sheet.querySelector("[data-el=ordno]").textContent = order || "—";
    sheet.querySelector("[data-el=ordmeta]").textContent =
      [who, when].filter(Boolean).join(" · ") || "no order details on the link";
    sheet.querySelector("[data-el=spec]").textContent = GIFT ? (GIFT.sku || "") : param("b");

    if (GIFT){
      var h1 = sheet.querySelector(".hd h1");
      if (h1) h1.textContent = "Gift set — build sheet";
      sheet.querySelector("[data-el=ordmeta]").textContent =
        [GIFT.set, GIFT.sku, who, when].filter(Boolean).join(" · ") || "no order details on the link";
      var hand = sheet.querySelector(".hand");
      // The note under the drawings is for the atelier's two views; the
      // bench does not need it on a gift set.
      if (hand) hand.style.display = "none";
      var ft = sheet.querySelector(".ft span");
      if (ft) ft.textContent = "Creator's Friend — gift set";
    }
  }

  var first = host.querySelector("[data-el=sheet]");
  var jobs = readJobs();

  // No job on the link at all still reaches paintSheet, so the "nothing to
  // draw" message is written in one place rather than two.
  if (!jobs.length) jobs = [job({})];

  // Cloned from a PRISTINE copy taken before anything is painted, not from
  // the sheet before it. Chaining the clones compounds the id suffixes
  // (`-foil--1--2`) and carries the previous job's painted drawing into the
  // next one to be overwritten — both work by luck rather than by design.
  var blank = first.cloneNode(true);
  paintSheet(first, jobs[0]);
  var after = first;
  for (var ji = 1; ji < jobs.length; ji++){
    var clone = blank.cloneNode(true);
    uniquifyIds(clone, ji);
    clone.className += " sheet--next";
    after.parentNode.insertBefore(clone, after.nextSibling);
    after = clone;
    paintSheet(clone, jobs[ji]);
  }

  /* ---- get it onto A4 and nothing else --------------------------------
     The sheet lives inside a Shopify page, under an announcement bar, a
     navigation rail and a footer, and the browser prints all of it — a
     one-page build sheet came out over three, none of them fitting.

     Identified by POSITION, not by name. The previous attempt listed theme
     class names to hide (`.header`, `.footer`, `.announcement-bar`); this
     theme uses none of them, so nothing was hidden and nothing failed
     either — it just quietly printed the whole page. Walking up from the
     sheet cannot go stale: everything that is not on the path from <body>
     to the sheet is, by definition, not part of the sheet. */
  function isolateForPrint(node){
    var n = node;
    while (n && n.parentNode && n.parentNode.nodeType === 1){
      var p = n.parentNode, kids = p.children, i;
      for (i = 0; i < kids.length; i++){
        if (kids[i] !== n && kids[i].classList) kids[i].classList.add("atlo-hide-print");
      }
      if (p.classList) p.classList.add("atlo-anc");
      n = p;
      if (p === document.body) break;
    }
  }
  isolateForPrint(host);
  /* Apps and the theme append to <body> long after this runs — a cart
     drawer, a chat bubble, a cookie notice. Anything that arrives later
     would print, so the walk is repeated once more when the browser is
     actually about to print. */
  window.addEventListener("beforeprint", function(){ isolateForPrint(host); });

  var lead = jobs[0], many = jobs.length > 1 ? " +" + (jobs.length - 1) : "";
  document.title = (lead("g") ? "Gift set sheet "
                   : lead("mono") ? ((lead("kind") || "") === "quote" ? "Quote sheet " : "Monogram sheet ")
                   : "Atelier order sheet ") +
                   (lead("o") || "") + many;
}


/* One init per sheet, and never twice. The theme editor re-renders a
   section without reloading the page, so `shopify:section:load` matters
   as much as DOMContentLoaded. */
function atelierOrderBoot(scope){
  (scope || document).querySelectorAll("[data-atelier-order]").forEach(function(host){
    if (host.dataset.atelierReady) return;
    host.dataset.atelierReady = "1";
    try { atelierOrderInit(host); }
    catch (e) { if (window.console) console.error("atelier-order:", e); }
  });
}
if (document.readyState === "loading")
  document.addEventListener("DOMContentLoaded", function(){ atelierOrderBoot(); });
else atelierOrderBoot();
document.addEventListener("shopify:section:load", function(e){ atelierOrderBoot(e.target); });